import axios from 'axios'

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    });

class serviceBase {
    constructor(uriBase) {
        this._uriBase = uriBase;
    }

    _getRoute(route) {
        return route ? `${this._uriBase}/${route}` : this._uriBase;
    }

    delete(route, params) {
        route = route || '';

        let config = this._createConfig();
        if (params) config.params = params;

        return axios.delete(this._getRoute(route), config);
    }

    get(route, params, responseType) {
        route = route || '';

        let config = this._createConfig();
        if (params) config.params = params;
        if (responseType) config.responseType = responseType;

        return axios.get(this._getRoute(route), config);
    }

    getSubdominio() {
        return window.location.host.split('.')[0];
    }

    put(route, data, params) {
        route = route || '';

        let config = this._createConfig();
        if (params) config.params = params;

        return axios.put(this._getRoute(route), data, config);
    }

    post(route, data, params) {
        route = route || '';

        let config = this._createConfig();
        if (params) config.params = params;

        return axios.post(this._getRoute(route), data, config);
    }

    _createConfig() {
        let config = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        }
        return config;
    }
}

export default serviceBase;